import { render, staticRenderFns } from "./estate-features-section.vue?vue&type=template&id=40fb425d&"
import script from "./estate-features-section.vue?vue&type=script&lang=js&"
export * from "./estate-features-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports